import { createContext, useContext } from 'react';
import type { Layer, LayerGroup, LayersControl, Map } from '@anlan/gs-map';
export type ControlledLayer = { addLayer(layer: Layer): void; removeLayer(layer: Layer): void };
export type LeafletContextInterface = Readonly<{ __version: number; map: Map; layerContainer?: ControlledLayer | LayerGroup; layersControl?: LayersControl; overlayContainer?: Layer; pane?: string }>;

export const CONTEXT_VERSION = 1;
export function createLeafletContext(map: Map): LeafletContextInterface {
    return Object.freeze({
        __version: CONTEXT_VERSION,
        map
    });
}
export function extendContext(source: LeafletContextInterface, extra: Partial<LeafletContextInterface>): LeafletContextInterface {
    return Object.freeze({
        ...source,
        ...extra
    });
}
export const LeafletContext = createContext<LeafletContextInterface | null>(null);
export const LeafletProvider = LeafletContext.Provider;
export function useLeafletContext() {
    const context = useContext(LeafletContext);
    if (context == null) {
        throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    }
    return context;
}
